export const BASE_GMAP_URL = "http://maps.google.com/maps";
export const LIVE_STREAM_SECRET_TOPIC_NAME = "Live Stream Discussion";
export const GENERAL_DISCUSSION_TOPIC_NAME = "General Discussion";
export const TEAM_CHAT_TOPIC_NAME = "Team Chat";
export const MAIL_INBOX_VIRTUAL_TOPIC_ID = "MAIL_INBOX";
export const EMBED_CTX_TALK = "talk";

export const EMBED_TALK_EVENT_RESTRICT = "EMBED_TALK_EVENT_RESTRICT";

export const FILE_SIZE_LIMIT_MB = 50; // 50 MB
export const BYTES_TO_UNIT_MB = 1024 * 1024; // 1 MB
export const MESSAGE_TEXT_LIMIT = 1024 * 4;
// Cumulative queue cap. Bounds fan-out emit storm + S3 PUT concurrency.
export const MAX_QUEUED_FILES = 5;

export const CONVERSATION_ROLES = {
  ALL: 1,
  ADMINS: 2,
  NONE: 3,
};

export const ConversationRolesMap = [
  { label: "Everyone", value: 1 },
  { label: "Only admins", value: 2 },
  { label: "No man's land", value: 3 },
];

export const NOTIFICATION_PREFERENCE = {
  ALL: 1,
  MENTIONS: 2,
  NONE: 3,
};

export const NOTIFICATIONS_PREFERENCE_MAP = {
  1: "Notify for all",
  2: "Notify for @mentions",
  3: "Notifications off",
};

export const ERROR_MESSAGE = {
  DEFAULT: "Unexpected error occurred.",
};

/**
 * Common abbreviations to exclude from URL detection in chat messages
 */
export const URL_DETECTION_COMMON_ABBREVIATIONS = [
  "e.g",
  "i.e",
  "etc.",
  "vs.",
  "mr.",
  "mrs.",
  "ms.",
  "dr.",
  "prof.",
  "inc.",
  "ltd.",
  "corp.",
  "co.",
  "st.",
  "ave.",
  "blvd.",
  "rd.",
  "jan.",
  "feb.",
  "mar.",
  "apr.",
  "jun.",
  "jul.",
  "aug.",
  "sep.",
  "oct.",
  "nov.",
  "dec.",
  "mon.",
  "tue.",
  "wed.",
  "thu.",
  "fri.",
  "sat.",
  "sun.",
  "a.m.",
  "p.m.",
  "am.",
  "pm.",
  // Academic degrees
  "b.sc",
  "b.sc.",
  "m.sc",
  "m.sc.",
  "b.a",
  "b.a.",
  "m.a",
  "m.a.",
  "b.tech",
  "b.tech.",
  "m.tech",
  "m.tech.",
  "ph.d",
  "ph.d.",
  "b.com",
  "b.com.",
  "m.com",
  "m.com.",
  "b.ed",
  "b.ed.",
  "m.ed",
  "m.ed.",
  "b.eng",
  "b.eng.",
  "m.eng",
  "m.eng.",
  "b.arch",
  "b.arch.",
  "mba.",
  "mba",
  "mbbs.",
  "mbbs",
  "ll.b",
  "ll.b.",
  "ll.m",
  "ll.m.",
  "b.pharm",
  "b.pharm.",
  "m.pharm",
  "m.pharm.",
  "b.des",
  "b.des.",
  "m.des",
  "m.des.",
  "ca.",
  "c.a.",
  "b.b.a",
  "b.b.a.",
  "m.b.a",
  "m.b.a.",
];

export const RECOMMENDED_PROGRAMS_MODE = {
  FREE: "FREE",
};

// Business hours constants (IST timezone)
export const BUSINESS_HOURS = {
  START: 9, // 9 AM IST
  END: 20, // 8 PM IST (20:00 in 24-hour format)
  TIMEZONE: "IST",
  UTC_OFFSET: 5.5, // IST is UTC + 5:30 hours
  WORKING_DAYS: [1, 2, 3, 4, 5, 6], // Monday (1) to Saturday (6), excluding Sunday (0)
};
